import { render, staticRenderFns } from "./productsSlider.vue?vue&type=template&id=3ea9dbf0&scoped=true"
import script from "./productsSlider.vue?vue&type=script&lang=js"
export * from "./productsSlider.vue?vue&type=script&lang=js"
import style0 from "./productsSlider.vue?vue&type=style&index=0&id=3ea9dbf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea9dbf0",
  null
  
)

export default component.exports